import { Clock, Car, Handshake, UserCheck, Layers, KeyRound } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const REASONS = [
  {
    icon: Clock,
    title: "Gain de temps",
    desc: "Nous prenons en charge les démarches afin de vous permettre de vous concentrer sur ce qui compte réellement.",
  },
  {
    icon: Car,
    title: "Expertise automobile",
    desc: "Une connaissance concrète du marché automobile et des véhicules d'occasion.",
  },
  {
    icon: Handshake,
    title: "Négociation",
    desc: "Nous cherchons à obtenir les meilleures conditions possibles pour nos clients.",
  },
  {
    icon: UserCheck,
    title: "Service personnalisé",
    desc: "Chaque client bénéficie d'une approche adaptée à ses besoins.",
  },
  {
    icon: Layers,
    title: "Accès à un vaste inventaire",
    desc: "Plus de 600 véhicules d'occasion accessibles à travers notre réseau.",
  },
  {
    icon: KeyRound,
    title: "Service clé en main",
    desc: "De la recherche à la livraison, nous pouvons coordonner l'ensemble du processus.",
  },
];

export default function WhyUs() {
  return (
    <section id="pourquoi" data-testid="why-us-section" className="py-24 md:py-32 bg-anthracite/60">
      <div className="container-x">
        <Reveal>
          <Chapter number="06" label="Pourquoi nous choisir" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight mb-14 max-w-2xl">
            La discrétion d'une firme privée,
            <br />
            <span className="gold-text">la rigueur d'un gestionnaire.</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={0.07 * (i % 3)}>
              <div data-testid={`why-card-${i + 1}`} className="card-lux h-full group">
                <span className="w-14 h-14 rounded-full border border-white/15 flex items-center justify-center text-gold mb-7 group-hover:border-gold/50 group-hover:bg-gold/5 transition-all duration-500">
                  <r.icon size={24} strokeWidth={1.25} />
                </span>
                <h3 className="text-sm uppercase tracking-[0.18em] text-white font-semibold mb-3">{r.title}</h3>
                <p className="text-sm text-slate-400 font-light leading-relaxed">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
